import React, { useState, useEffect } from 'react';
import { getDynamicBorderColor } from '../utils';

export default function ScoreBadge({ score }) {
  const r = 38;
  const circ = 2 * Math.PI * r;
  const [animScore, setAnimScore] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setAnimScore(score), 120);
    return () => clearTimeout(t);
  }, [score]);

  const offset = circ - (animScore / 100) * circ;
  const color = getDynamicBorderColor(score);

  return (
    <div style={{ position: 'relative', width: 90, height: 90, flexShrink: 0 }}>
      <svg width="90" height="90" viewBox="0 0 90 90" style={{ transform: 'rotate(-90deg)' }}>
        <circle cx="45" cy="45" r={r} fill="none" stroke="rgba(240,236,224,0.09)" strokeWidth="5" />
        <circle cx="45" cy="45" r={r} fill="none"
          stroke={color} strokeWidth="5" strokeLinecap="round"
          strokeDasharray={circ} strokeDashoffset={offset}
          style={{
            transition: 'stroke-dashoffset 1.3s cubic-bezier(0.34,1.56,0.64,1)',
            filter: score >= 50 ? `drop-shadow(0 0 5px ${color}99)` : 'none',
          }}
        />
      </svg>
      <div style={{
        position: 'absolute', inset: 7, borderRadius: '50%', background: '#20201a',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1,
      }}>
        <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 6.5, letterSpacing: '0.16em', color: 'rgba(240,236,224,0.3)', textTransform: 'uppercase' }}>
          Grill Score
        </span>
        <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 26, lineHeight: 1, color }}>
          {score}
        </span>
      </div>
    </div>
  );
}
